export const getAlertTypeProps = (variant) => {
  const alertTypeProps = {};
  if (['success', 'error', 'warning', 'info', 'danger', 'default'].includes(variant)) {
    alertTypeProps[variant] = true;
  }
  return alertTypeProps;
};

export const getDefaultConfirmStyle = (variant) => {
  return variant === 'error' || variant === 'danger' ? 'danger' : 'primary';
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/SweetAlert/utils/sweetAlertHelpers.js